import { usePagesPage } from "modules/brands/context";
import { PagesTabs } from "modules/brands/context/types";
import { FC } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import FlexColumn from "shared/components/Layout/components/FlexColumn";
import Switcher from "shared/components/Switcher";
import PagePreview from "./components/PagePreview";
import SchedulePreview from "./components/SchedulePreview";

const Pages: FC = () => {
  const { activeTab, setActiveTab } = usePagesPage();
  return (
    <FlexColumn marginTop="1rem">
      <FlexCenter
        marginBottom={"1rem"}
        gap="1rem"
        flexDirection="column"
        alignItems="flex-start"
      >
        <Switcher
          options={[
            { id: PagesTabs.Preview, label: "Page Preview" },
            { id: PagesTabs.Schedule, label: "Schedule" },
          ]}
          activeOptionId={activeTab}
          onChange={(optionId) => setActiveTab(optionId as PagesTabs)}
        />
      </FlexCenter>

      {activeTab === PagesTabs.Preview && <PagePreview />}
      {activeTab === PagesTabs.Schedule && <SchedulePreview />}
    </FlexColumn>
  );
};

export default Pages;
